<template>
  <div class="sponsors-wrapper">
    <div class="panel" v-for="(section, index) in sections" :key="index">
      <div class="panel__title">{{ section.title }}</div>
      <div class="panel__content sponsors">
        <div
          class="sponsor"
          v-for="(sponsor, index2) in section.sponsors"
          :key="index2"
        >
          <component
            :is="sponsor.url ? 'a' : 'div'"
            class="sponsor__link"
            :class="{ 'sponsor__link-largefont': sponsor.largefont }"
            target="_blank"
            :href="sponsor.url"
          >
            <img v-if="sponsor.logo" :src="sponsor.logo" :alt="sponsor.name" />
            <div v-else v-html="sponsor.name"></div>
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data() {
    const getImage = (name) => require(`@/assets/sponsors/${name}.png`);

    return {
      sections: [
        {
          title: "Presented by",
          sponsors: [
            {
              name: "CocaCola & Southern Company",
              url: "",
              logo: getImage("main"),
            },
          ],
        },
        {
          title: "Additional Support Provided By",
          sponsors: [{ name: "NBC Golf", url: "", logo: getImage("golf") }],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.sponsors {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 30px;
}

.sponsors-wrapper {
  margin: 0 30px 50px 30px;
  padding: 10px;
}

.sponsor {
  margin: 25px;

  &__link {
    text-transform: capitalize;
    color: #676767;
    line-height: 1.2;
    text-decoration: none;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 6px;
    white-space: pre-line;

    img {
      max-height: 90px;
    }
  }
}

.sponsor__link {
  font-size: 18px;
  &.sponsor__link-largefont {
    font-size: 36px;
  }
}

@media screen and (max-width: 1264px) {
  .sponsors-wrapper {
    margin: 40px;
  }
}

@media screen and (max-width: 800px) {
  .sponsors-wrapper {
    margin: 20px;
  }

  .sponsor {
    margin: 6px;
    max-width: 45%;
  }

  .sponsor__link {
    font-size: 14px;
    &.sponsor__link-largefont {
      font-size: 18px;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
